import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseEdit } from '../base-edit';
import { ViewModelProperty } from '../../models';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatPrefix, MatSuffix } from '@angular/material/form-field';

import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatInput } from '@angular/material/input';
import { MatIconButton } from '@angular/material/button';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
  selector: 'ldw-button-edit',
  templateUrl: './button-edit.component.html',
  styleUrls: ['./button-edit.component.css'],
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatIcon,
    MatPrefix,
    MatTooltip,
    MatInput,
    MatIconButton,
    MatSuffix,
    MatProgressBar
  ]
})
export class ButtonEditComponent extends BaseEdit {
  @Input() clearButtonEnabled = false;
  @Output() actionClicked = new EventEmitter<ViewModelProperty>();
}
